(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/init.js'); "use strict";

var setupVideoFromAttributes = svs.components.emp_video_player.helpers.client.setupVideoFromAttributes;

function init() {
  var videoElements = document.getElementsByClassName('js-emp-placeholder');

  for (var i = 0; i < videoElements.length; i++) {
    var element = videoElements[i];
    setupVideoFromAttributes(element);
  }

  svs.events.subscribe('/video/banner', function (options) {
    var banner = options.banner,
        bannerElement = options.bannerElement;

    if (banner && banner.video && banner.video.type === 'redbee') {
      var _element = bannerElement[0].querySelector('.js-emp-placeholder');

      setupVideoFromAttributes(_element);
    }
  });
}

init();
 })(window);